import React, {lazy, Suspense} from 'react'

const ProfileLazy = lazy(() =>
    import('./Profile')
)

const Profile = props => (
    <Suspense fallback={null}>
        <ProfileLazy {...props} />
    </Suspense>
)

export default Profile
